import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { createUser } from "utils/userThunk"; // adjust path as needed
import toast from "react-hot-toast"; // optional for feedback

const validationSchema = Yup.object({
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
  email: Yup.string().email("Invalid email address").required("Email is required"),
  phone: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone must be 10 digits")
    .required("Phone is required"),
  date_of_birth: Yup.date()
    .required("Date of birth is required")
    .max(new Date(), "Date of birth cannot be in the future"),
  exam_type: Yup.string().required("Exam type is required"),
});

const initialValues = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  date_of_birth: "",
  exam_type: "",
};

const AddStudentModal = ({ handleSubmit, closeModal }) => {
  const dispatch = useDispatch();

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      console.log("Enter key prevented from submitting form");
    }
  };

  return (
    <div className="modal fade" id="add_student">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="fw-bold">Add New Student</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              onClick={closeModal}
              aria-label="Close modal"
            />
          </div>
          <div className="modal-body">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values, { resetForm }) => {
                console.log("Add student form submitted with values:", values);
                handleSubmit(values, { resetForm });
              }}
              validateOnChange
              validateOnBlur
            >
              {({ values, touched, errors }) => (
                <Form id="add-student-form" onKeyDown={handleKeyDown}>
                  <div className="mb-3">
                    <label className="form-label" htmlFor="first_name">First Name</label>
                    <Field
                      type="text"
                      name="first_name"
                      id="first_name"
                      className="form-control"
                    />
                    {touched.first_name && errors.first_name && (
                      <div className="text-danger">{errors.first_name}</div>
                    )}
                  </div>

                  <div className="mb-3">
                    <label className="form-label" htmlFor="last_name">Last Name</label>
                    <Field
                      type="text"
                      name="last_name"
                      id="last_name"
                      className="form-control"
                    />
                    {touched.last_name && errors.last_name && (
                      <div className="text-danger">{errors.last_name}</div>
                    )}
                  </div>

                  <div className="mb-3">
                    <label className="form-label" htmlFor="email">Email</label>
                    <Field
                      type="email"
                      name="email"
                      id="email"
                      className="form-control"
                    />
                    {touched.email && errors.email && (
                      <div className="text-danger">{errors.email}</div>
                    )}
                  </div>

                  <div className="mb-3">
                    <label className="form-label" htmlFor="phone">Phone Number</label>
                    <Field
                      type="text"
                      name="phone"
                      id="phone"
                      className="form-control"
                    />
                    {touched.phone && errors.phone && (
                      <div className="text-danger">{errors.phone}</div>
                    )}
                  </div>

                  <div className="mb-3">
                    <label className="form-label" htmlFor="date_of_birth">Date of Birth</label>
                    <Field
                      type="date"
                      name="date_of_birth"
                      id="date_of_birth"
                      className="form-control"
                    />
                    {touched.date_of_birth && errors.date_of_birth && (
                      <div className="text-danger">{errors.date_of_birth}</div>
                    )}
                  </div>

                  {/* ✅ Exam Type Select */}
                  <div className="mb-3">
                    <label className="form-label" htmlFor="exam_type">Exam Type</label>
                    <Field
                      as="select"
                      name="exam_type"
                      id="exam_type"
                      className="form-select"
                    >
                      <option value="">Select Exam Type</option>
                      <option value="CSA">CSA</option>
                      <option value="Loader / Housekeeping">Housekeeping</option>
                    </Field>
                    {touched.exam_type && errors.exam_type && (
                      <div className="text-danger">{errors.exam_type}</div>
                    )}
                  </div>

                  <div className="modal-footer mt-3">
                    <button
                      type="button"
                      className="btn bg-gray-100 rounded-pill mx-2"
                      data-bs-dismiss="modal"
                      onClick={closeModal}
                      aria-label="Cancel"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-secondary rounded-pill"
                      aria-label="Submit"
                    >
                      Submit
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddStudentModal;
